import { Component, inject, Input, OnInit } from '@angular/core';
import { ProjectsFeatureService, TaskNode, TimesheetsFeatureService } from '@features';
import { MatListModule } from '@angular/material/list';
import { DecimalPipe } from '@angular/common';
import { HighlightPipe } from '../../../../../utils/highlight.pipe';

@Component({
  selector: 'app-phases',
  standalone: true,
  imports: [MatListModule, DecimalPipe, HighlightPipe],
  templateUrl: './phases.component.html',
  styleUrl: './phases.component.css',
})
export class PhasesComponent implements OnInit {
  @Input({ required: true }) projectNo!: string;
  _projectsFeature = inject(ProjectsFeatureService);
  _timesheetFeature = inject(TimesheetsFeatureService);

  constructor() {}

  ngOnInit() {}

  handleSelectingPhase(projectNo: string, phaseNo: string) {
    this._timesheetFeature.handleOpeningAddHourDialogForProject(projectNo, phaseNo);
  }

  handleSelectingTask(task: TaskNode) {
    this._timesheetFeature.handleOpeningAddHourDialogForProject(task.projectNo, task.phaseNo, task.taskNo);
  }
}
